import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { CountdownTimer } from "./CountdownTimer";
import { PRICE } from "../src/config";
const includes = ["Ebook completo: The Bilingual Sales Machine", "Bono #1 · Native-Voice Prompts ($47)", "Bono #2 · El Script de los $10.000 ($37)", 'Bono #3 · Guía "Dólares en Mano" ($27)', "Bono #4 · LinkedIn Mastery AI ($17)", "Bono #5 · 10 Nichos Ganadores 2026 ($17)"];
export function PriceSection() {
  return <section id="oferta" className="w-full bg-gradient-to-b from-[#12102a] to-[#0a0a1f] py-16" data-id="element-166" data-mp="2vkt3t6a2gpca">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-167" data-mp="2qlpwff6m6715">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="overflow-hidden rounded-3xl border border-violet-500/30 bg-[#0d0b22] shadow-2xl shadow-violet-900/30" data-id="element-168" data-mp="2mitgjw8gkp0w">
          <div className="bg-violet-600 px-6 py-3 text-center text-sm font-bold uppercase tracking-wider text-white" data-id="element-169" data-mp="1mhucfzbo1npf">
            Oferta de lanzamiento · Termina pronto
          </div>

          <div className="p-6 sm:p-8" data-id="element-170" data-mp="1diz86ss6mnor">
            <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-171" data-mp="1dk0nj9g8dwca">
              Llévate todo el sistema hoy
            </h2>

            <div className="mt-5 flex items-end justify-center gap-3" data-id="element-172" data-mp="25a54sz8p239a">
              <span className="text-2xl text-slate-500 line-through" data-id="element-173" data-mp="2a8q2os0h4auk">$172</span>
              <span className="font-display text-6xl font-extrabold text-emerald-400" data-id="element-174" data-mp="1wgs1d3d07j8y">
                {PRICE}
              </span>
            </div>
            <p className="mt-1 text-center text-sm text-slate-400" data-id="element-175" data-mp="20h2h37qllo10">
              Menos que un combo de hamburguesa. Pago único.
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-176" data-mp="2o64ziht23kwk">
              {includes.map(item => <li key={item} className="flex items-start gap-3 text-slate-200" data-id="element-177" data-mp="2t0ski6oupx6e">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" data-id="element-178" data-mp="32tvi9beh9qvr" />
                  <span className="text-sm" data-id="element-179" data-mp="2yue8w6vxk9lb">{item}</span>
                </li>)}
            </ul>

            <div className="mt-6 flex flex-col items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-4" data-id="element-180" data-mp="2tsf9t9783yu6">
              <span className="text-xs uppercase tracking-wider text-slate-400" data-id="element-181" data-mp="2ox9lk3qcm82x">
                Este precio expira en
              </span>
              <CountdownTimer minutes={15} data-id="element-182" data-mp="2f4u375b53hhi" />
            </div>

            <CTAButton className="mt-6" destination="checkout" subtext="Acceso inmediato tras el pago · Garantía de 7 días" data-id="element-183" data-mp="2f39cxrvuykpg" />
          </div>
        </motion.div>
      </div>
    </section>;
}